module.exports = __webpack_public_path__ + "static/media/postFashionLogo.69346de5.png";